import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentProps } from 'preact';

import { useHabitatLiveStreamPlayerContext } from './contexts';

const HabitatLiveStreamPlayerPauseContent = (props: Omit<ComponentProps<'button'>, 'ref' | 'className'>) => {
  const { habitat } = useHabitatLiveStreamPlayerContext();
  const backgroundImage = habitat.offlineImage || habitat.wideImage;

  return (
    <button
      type="button"
      className="preflight preflight-button absolute inset-0 flex flex-col items-center justify-center bg-black p-2"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt="background"
          className="preflight preflight-img absolute inset-0 size-full object-cover"
        />
      )}
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/75">
        <FontAwesomeIcon icon={faPlay} color="white" className="text-[24px] desktop:text-[64px]" />
        <p className="preflight preflight-p max-w-[400px] text-center text-white desktop:text-lg desktop:font-bold">
          <span className="mb-1 mt-3 inline-block text-xs desktop:mb-6 desktop:mt-12 desktop:text-2xl">Stream Paused</span>
          <br />
          <span className="text-[10px] desktop:text-base">Click to resume playing.</span>
        </p>
      </div>
    </button>
  );
};

export default HabitatLiveStreamPlayerPauseContent;
